import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { type ResourcesConfig } from '@aws-amplify/core';

export const cognitoConfig = {
  userPoolClientId: '16vqefi47hrbph2vjvj6pt0qij',
  userPoolId: 'ap-northeast-1_4ErM5gKqQ',
  region: 'ap-northeast-1'
};

// 認証の設定
const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId
    }
  }
};

// 認証状態の初期化
(async () => {
  try {
    Amplify.configure(config);
    await fetchAuthSession();
  } catch (error) {
    console.log('No existing auth session');
  }
})();